import React from 'react';
import { Flex, Spinner } from 'core/components';
import KaizenPaintedDoor from './KaizenPaintedDoor';
import KaizenDesktopLayout from './KaizenDesktopLayout';

const KaizenMainContent = ({
  hasAi,
  loading,
  loadingStores,
  isScrolledToBottom,
  isExistingChatLoading,
  inputRef,
  scrollAreaRef,
  onScroll,
  onScrollToBottom,
  onSelectToolResult,
  onCreateJourney,
  onSelectJourneyAfterCreation,
  isSidebarCollapsed,
  selectedToolResults,
  onCloseToolResult,
  onCloseToolResults,
  onSelectJourney
}) => {
  // Show painted door if AI is not enabled
  if (!hasAi) {
    return <KaizenPaintedDoor />;
  }

  // Show loading spinner while stores are loading
  if (loading || loadingStores) {
    return (
      <Flex
        width="100%"
        height="100%"
        flex={1}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        bg="decks.background"
        pt={0}
        overflow="auto"
      >
        <Spinner />
      </Flex>
    );
  }

  return (
    <KaizenDesktopLayout
      isSidebarCollapsed={isSidebarCollapsed}
      selectedToolResults={selectedToolResults}
      isScrolledToBottom={isScrolledToBottom}
      isExistingChatLoading={isExistingChatLoading}
      inputRef={inputRef}
      scrollAreaRef={scrollAreaRef}
      onScroll={onScroll}
      onScrollToBottom={onScrollToBottom}
      onSelectToolResult={onSelectToolResult}
      onCloseToolResult={onCloseToolResult}
      onCloseToolResults={onCloseToolResults}
      onCreateJourney={onCreateJourney}
      onSelectJourneyAfterCreation={onSelectJourneyAfterCreation}
      onSelectJourney={onSelectJourney}
    />
  );
};

export default KaizenMainContent;
